import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { Parametro } from "app/types/Parametro";
import { IProduto } from "app/types/produto/IProduto";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import * as R from "ramda";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DetalhesProduto } from "./DetalhesProduto";


export type DetalhesProdutoContainerProps = {
  produto: IProduto;
  mascara: string
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  orcamentoForaModuloVendas: boolean
  desabilitarPesquisarHistorico: boolean
  onVoltar: () => void,
};

export const DetalhesProdutoContainer = (props: DetalhesProdutoContainerProps) => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [parametros, setParametros] = useState<Parametro[]>([]);

  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
  const isMounted = useRef(true);

  const atualizarValoresParametros = async () => {
    await R.pipe(
      () =>
        obterParametros({
          nomes: [
            "EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS",
            "EXIBIR_QUANTIDADE_MINIMA_VENDA_CONSULTA_PRODUTOS",
            "EXIBIR_ESTOQUE_OUTRAS_FILIAIS",
          ],
        }),
      R.andThen((resultado: Parametro[]) => {
        if (isMounted.current) {
          setParametros(resultado);
        }
      })
    )();
  };

  const onPassoSelecionado = useCallback((passo: string) => {
    passosInterno.current.get(passo)()
  }, []);

  const onVoltar = useCallback(() => {
    props.onVoltar()
  }, [props.onVoltar]);

  const valorParametro = useCallback(
    (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor,
    [parametros]
  );

  useEffect(() => {
    isMounted.current = true;
    passosInterno.current.set("Detalhes do Produto", () => { renderizarComponentReact(<DetalhesProdutoContainer {...props} />, props.regiaoRenderizada, true) })
    atualizarValoresParametros();

    return () => {
      isMounted.current = false;
    };
  }, []);


  return (
    <>
      <Breadcrumb2Container
        passos={passosInterno.current.keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="DetalhesProdutoContainer"
        onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
      />

      <DetalhesProduto
        item={props.produto}
        mascara={props.mascara}
        exibirComissaoVenda={
          valorParametro("EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS") == "S"
        }
        exibirQuantidadeMinimaDeVenda={
          valorParametro("EXIBIR_QUANTIDADE_MINIMA_VENDA_CONSULTA_PRODUTOS") ==
          "S"
        }
        exibirEstoques={valorParametro("EXIBIR_ESTOQUE_OUTRAS_FILIAIS") == "S"}
      />
    </>
  );
};
